module.exports = __webpack_public_path__ + "static/media/left-arrow.5bd96136.svg";